// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3egNi","unreadBadge":"styles_unreadBadge__3CAqM","modalContent":"styles_modalContent__j3P2u","modal":"styles_modal__3T0Me"};